module.exports = __webpack_public_path__ + "static/media/rocket_lander_3d_2.58c00187.webp";